// extracted by mini-css-extract-plugin
export var buttonContainer = "errorPage-module--button-container--14528";
export var buttonContainer404 = "errorPage-module--button-container-404--0bc17";
export var errorPageWrapper = "errorPage-module--error-page-wrapper--2dc00";
export var header = "errorPage-module--header--d7ddd";
export var helpCenterButton = "errorPage-module--help-center-button--b83b4";
export var iconWrapper = "errorPage-module--icon-wrapper--11390";
export var secondaryText = "errorPage-module--secondary-text--d5164";